import { makeStyles } from '@mui/styles';
// colors
import { colors } from '../../../colors';

export const useStyles = makeStyles({
  root: {
    border: `2px dashed ${colors.neutral100}`,
    borderRadius: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 152,
    width: '100%',
    padding: '36px 24px 32px',
  },
  dragging: {
    border: `1px solid ${colors.primary}`,
  },
  disabled: {
    opacity: 0.7,
    '& $uploadText span': {
      cursor: 'default',
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  icon: {
    color: colors.primary,
    width: 32,
    height: 32,
  },
  uploadText: {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '24px',
    color: colors.neutral500,
    margin: '8px 0',
    '& span': {
      color: colors.primary,
      cursor: 'pointer',
    },
  },
  filesize: {
    color: colors.neutral500,
    fontSize: 12,
    fontWeight: 600,
  },
});
